import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from './ui/alert-dialog';

const ARCHIVE_REASONS = [
  { value: 'died', label: 'Died' },
  { value: 'sold', label: 'Sold' },
  { value: 'given_away', label: 'Given Away' },
  { value: 'discarded', label: 'Discarded' },
  { value: 'other', label: 'Other' },
];

export const ArchiveDialog = ({ isOpen, plantName, onConfirm, onCancel }) => {
  const [reason, setReason] = useState('');

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => { if (!open) onCancel(); }}>
      <AlertDialogContent style={{ backgroundColor: 'white' }} data-testid="archive-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle style={{ color: 'hsl(143, 28%, 25%)', fontSize: '1.25rem' }} data-testid="archive-dialog-title">
            Archive Plant
          </AlertDialogTitle>
          <AlertDialogDescription style={{ color: 'hsl(125, 12%, 25%)' }}>
            Move <strong>{plantName}</strong> to the archive. You can restore it later.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2 py-2">
          <p className="text-sm font-medium text-gray-700">Reason:</p>
          {ARCHIVE_REASONS.map(opt => (
            <label
              key={opt.value}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer border transition-all ${
                reason === opt.value
                  ? 'border-green-600 bg-green-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              data-testid={`archive-reason-${opt.value}`}
            >
              <input
                type="radio"
                name="archive_reason"
                value={opt.value}
                checked={reason === opt.value}
                onChange={() => setReason(opt.value)}
                className="accent-green-700"
              />
              <span className="text-sm">{opt.label}</span>
            </label>
          ))}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel
            style={{ borderColor: 'hsl(143, 28%, 85%)', color: 'hsl(143, 28%, 25%)' }}
            data-testid="archive-cancel-btn"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => { if (reason) onConfirm(reason); }}
            disabled={!reason}
            style={{ backgroundColor: reason ? 'hsl(143, 28%, 35%)' : 'hsl(143, 28%, 70%)', color: 'white' }}
            data-testid="archive-confirm-btn"
          >
            Archive
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
